(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-banner-custom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSlider = (root) => {
      if (!root || root.dataset.sliderReady === 'true') return;

      const track = root.querySelector('[data-wh-banner-track]');
      const slides = [...root.querySelectorAll('[data-wh-banner-slide]')];
      const dots = [...root.querySelectorAll('[data-wh-banner-dot]')];
      const prevBtn = root.querySelector('[data-wh-banner-prev]');
      const nextBtn = root.querySelector('[data-wh-banner-next]');
      const total = slides.length;
      const autoplayMs = Number(root.dataset.autoplayMs || 4000);
      let index = 0;
      let intervalId;

      if (!track || total === 0) return;

      root.dataset.sliderReady = 'true';

      const updateUI = () => {
        track.style.transform = `translateX(-${index * 100}%)`;
        dots.forEach((dot, i) => {
          const isActive = i === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const goTo = (nextIndex) => {
        index = (nextIndex + total) % total;
        updateUI();
      };

      const restartAutoplay = () => {
        if (intervalId) clearInterval(intervalId);
        intervalId = setInterval(() => goTo(index + 1), autoplayMs);
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const nextIndex = Number(dot.dataset.slideIndex || 0);
          goTo(nextIndex);
          restartAutoplay();
        });
      });

      prevBtn?.addEventListener('click', () => {
        goTo(index - 1);
        restartAutoplay();
      });

      nextBtn?.addEventListener('click', () => {
        goTo(index + 1);
        restartAutoplay();
      });

      root.addEventListener('mouseenter', () => clearInterval(intervalId));
      root.addEventListener('mouseleave', restartAutoplay);

      updateUI();
      restartAutoplay();
    };

    const initAll = () => {
      document.querySelectorAll('[data-wh-banner-slider]').forEach((root) => {
        root.dataset.sliderReady = 'false';
        initSlider(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
